import { render, staticRenderFns } from "./favourite.vue?vue&type=template&id=70029916&"
import script from "./favourite.vue?vue&type=script&lang=js&"
export * from "./favourite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports